import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowUpRight, Loader2 } from "lucide-react";
import { waLink } from "../../lib/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const services = [
  "Website Design",
  "Website Development",
  "SEO",
  "Branding & Marketing",
  "Complete Website (Design + Build)",
  "Not sure yet",
];

export const LeadForm = ({ compact = false }) => {
  const [form, setForm] = useState({ name: "", service: "", details: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      axios.post(`${API}/leads`, form).catch(() => {});
      const msg = `Hi Ritesh! I'm ${form.name}.\nService I need: ${form.service}\nAbout my project: ${form.details || "Will explain on chat"}`;
      window.open(waLink(msg), "_blank", "noopener");
      toast.success("Opening WhatsApp — your details are pre-filled. Just hit send!");
      setForm({ name: "", service: "", details: "" });
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="lead-form" className="space-y-4">
      <input
        data-testid="lead-name-input"
        required
        value={form.name}
        onChange={set("name")}
        placeholder="Your name *"
        className="field"
        aria-label="Your name"
      />
      <select
        data-testid="lead-service-select"
        required
        value={form.service}
        onChange={set("service")}
        className="field appearance-none"
        aria-label="Service you need"
      >
        <option value="" disabled>Service you need *</option>
        {services.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      <textarea
        data-testid="lead-details-input"
        rows={compact ? 3 : 4}
        value={form.details}
        onChange={set("details")}
        placeholder="Brief description — what does your business do, what should the website achieve?"
        className="field resize-none"
        aria-label="Brief project description"
      />
      <button
        data-testid="lead-form-submit-button"
        type="submit"
        disabled={sending}
        className="btn-lime group w-full inline-flex items-center justify-center gap-3 px-6 py-4 font-semibold text-sm tracking-wide disabled:opacity-60"
      >
        {sending ? <Loader2 size={16} className="animate-spin" /> : null}
        Send &amp; Continue on WhatsApp
        {!sending && <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:rotate-45" />}
      </button>
      <p className="text-center font-mono text-[10px] tracking-[0.18em] uppercase text-mute" data-testid="lead-form-trust-line">
        No advance until you approve the demo · 7-day delivery
      </p>
    </form>
  );
};
